import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const MyCalendarApp = lazy(() => import('./MyCalendar'));

const MyCalendarConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/my-calendar',
      element: <MyCalendarApp />,
    },
  ],
};

export default MyCalendarConfig;
